const updateHours = (hour: number, setHours: (val: number) => void, type: string) => {
  const isIncrease = type === 'up'
  let hourRef = hour
  if (hour < 12 && isIncrease) {
    ++hourRef
  } else if (hour > 1 && !isIncrease) {
    --hourRef
  } else if (!isIncrease && hour < 2) {
    hourRef = 12
  } else if (isIncrease && hour > 11) {
    hourRef = 1
  }
  return setHours(hourRef)
}

const updateMinute = (minute: number, setMinutes: (val: number) => void, type: string) => {
  const isIncrease = type === 'up'
  let minuteRef = minute
  if (minuteRef < 59 && isIncrease) {
    ++minuteRef
  } else if (minute > 0 && !isIncrease) {
    --minuteRef
  } else if (!isIncrease && minute < 1) {
    minuteRef = 59
  } else if (isIncrease && minute > 58) {
    minuteRef = 0
  }
  return setMinutes(minuteRef)
}

const updateMeridianInfo = (meridian: string, updateMeridian: (val: string) => void) => {
  let meridianRef = meridian
  if (meridianRef === 'AM') {
    updateMeridian('PM')
  } else {
    updateMeridian('AM')
  }
}

const returnFunctionType = (
  type: string,
  id: string,
  hour: number,
  setHours: (val: number) => void,
  minute: number,
  setMinutes: (val: number) => void,
  meridian: string,
  updateMeridian: (val: string) => void,
) => {
  const isHour = type === 'hour'
  const isMinute = type === 'minute'
  if (isHour) {
    return updateHours(hour, setHours, id)
  } else if (isMinute) {
    return updateMinute(minute, setMinutes, id)
  } else {
    return updateMeridianInfo(meridian, updateMeridian)
  }
}

export { updateMeridianInfo, updateMinute, updateHours, returnFunctionType }
